import { useState } from 'react';
import { testimonials } from '../../../mocks/testimonials';
import useInView from '../../../hooks/useInView';

const ReviewsSection = () => {
  const [expanded, setExpanded] = useState<number | null>(null);
  const { ref: headerRef, inView: headerInView } = useInView();
  const { ref: cardsRef, inView: cardsInView } = useInView();

  return (
    <section id="reviews" className="py-10 md:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={headerRef}
          className={`flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-16 transition-all duration-700 ease-out ${headerInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <div>
            <p className="text-[#C41E3A] text-sm font-bold uppercase tracking-widest mb-3">Customer Reviews</p>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#111827] mb-4 sm:mb-5">
              Real Results, Real Customers
            </h2>
            <p className="text-base sm:text-lg text-[#6B7280] max-w-xl">
              Thousands of homeowners trust Renova. Here&apos;s what they have to say.
            </p>
          </div>
          <div className="flex items-center space-x-6 sm:space-x-8 mt-6 md:mt-0">
            {[
              { platform: 'Google', rating: '4.9', count: '3,200+', icon: 'ri-google-fill' },
              { platform: 'BBB', rating: 'A+', count: 'Accredited', icon: 'ri-star-fill' },
            ].map((p) => (
              <div key={p.platform} className="text-center">
                <div className="flex items-center justify-center space-x-1 mb-1">
                  <i className={`${p.icon} text-[#C41E3A] text-xl`} />
                  <span className="text-2xl font-bold text-[#111827]">{p.rating}</span>
                </div>
                <p className="text-xs text-[#6B7280]">{p.platform} · {p.count}</p>
              </div>
            ))}
          </div>
        </div>

        <div ref={cardsRef} className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={t.id}
              style={{ transitionDelay: `${i * 100}ms` }}
              className={`bg-[#EEF5FF] rounded-xl p-6 border border-[#1A56A0]/15 flex flex-col transition-all duration-700 ease-out ${cardsInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
            >
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(t.rating)].map((_, idx) => (
                  <i key={idx} className="ri-star-fill text-yellow-400 text-sm" />
                ))}
              </div>
              <p className={`text-sm text-[#374151] leading-relaxed mb-5 flex-1 ${expanded === t.id ? '' : 'line-clamp-4'}`}>
                &quot;{t.text}&quot;
              </p>
              {t.text.length > 180 && (
                <button
                  onClick={() => setExpanded(expanded === t.id ? null : t.id)}
                  className="text-xs text-[#C41E3A] font-semibold mb-4 text-left cursor-pointer"
                >
                  {expanded === t.id ? 'Show less' : 'Read more'}
                </button>
              )}
              <div className="border-t border-[#E2E8F0] pt-4">
                <p className="text-sm font-bold text-[#111827]">{t.name}</p>
                <div className="flex items-center justify-between mt-1">
                  <p className="text-xs text-[#6B7280]">{t.location}</p>
                  <p className="text-xs text-[#C41E3A] font-medium">{t.service}</p>
                </div>
                <p className="text-xs text-[#9CA3AF] mt-1">{t.date}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
